import { BehaviorSubject } from 'rxjs';

export default class UploadProgressRepository {
  uploading$ = new BehaviorSubject(false);
  progress$ = new BehaviorSubject(0);

  reset() {
    this.uploading$.next(false);
    this.progress$.next(0);
  }

  start() {
    this.uploading$.next(true);
    this.progress$.next(0);
  }

  finish() {
    this.progress$.next(100);
    this.uploading$.next(false);
  }

  fail() {
    this.uploading$.next(false);
  }
}
